import React from 'react';
import classNames from 'classnames';
import { InputNumber } from 'primereact/inputnumber';
import { useTranslation } from 'react-i18next';
import { DynamicFormFieldProps } from '../../types/types';
import { getDynamicFieldTooltip } from '../../../utils/helper';
import { isAttributeDisabled } from '../../../utils/attribute';

type Props = DynamicFormFieldProps;

export default function MetricInput({
  attribute,
  field,
  fieldState,
}: Props) {
  const { i18n } = useTranslation();

  // TODO: Add dynamic unit
  // const unit = ' m';

  return (
    <InputNumber
      onValueChange={field.onChange}
      value={field.value}
      // suffix={unit}
      inputId={field.name}
      locale={i18n.language}
      className={classNames({ 'w-full': true, 'p-invalid': fieldState.error })}
      disabled={isAttributeDisabled(attribute)}
      {...getDynamicFieldTooltip(attribute)}
    />
  );
}
